import { HeroBackground, ProductMain } from '@prishapolicy/shared/ui';
import {
  ChoosePlan,
  ChoosePlanProps,
  Faq,
  getPurchaseFlowHeroForms,
  HeroTicker,
  otherfaqList,
  ProductCategoryPageProps,
  productsPathAdder,
  ProtectToday,
  useW3PurchaseFlow,
  WhyChooseUs,
} from '@prishapolicy/w3/ui';
import { NextSeo } from 'next-seo';
import Image from 'next/image';

import heroImage from './hero-image.png';
import rightIllustration from './rightIllustration.png';

const productCategorySlug = 'other-insurances';
export function LiabilityInsurance(props: ProductCategoryPageProps) {
  const choosePlanCards: ChoosePlanProps['cards'] = [
    {
      title: 'Principle of Utmost Good Faith',
      content: (
        <div>
          An insurance contract is a contract of &lsquo;uberrimae fidei&rsquo;. The Principle of Utmost Good Faith
          states that both the parties of an insurance contract should have good faith towards each other. Also, each
          party should communicate the terms and conditions in a non-ambiguous manner to the other.
        </div>
      ),
    },
    {
      title: 'Principle of Insurable Interest',
      content: (
        <div>
          Having some economic or pecuniary interest in the subject matter of the insurance policy or contract is known
          as Insurable Interest. The Principle of Insurable Interest states that the insured must have the insurable
          interest in the subject matter of the insurance.
        </div>
      ),
    },
    {
      title: 'Principle of Mitigation',
      content: (
        <div>
          According to the Principle of Mitigation, the insured is obligated to take reasonable steps to minimize the
          damage to the insured subject. The aim behind this principle is to ensure that the insured does not become
          careless towards the insured subject after taking the policy for covering the risks.
        </div>
      ),
    },
    {
      title: 'Principle of Indemnity',
      content: (
        <div>
          Indemnity means &lsapos;Security against Loss&rsapos;. The Principle of Indemnity aims at putting the insured
          (in the event of loss) in the exact same position the insured has immediately before the occurrence of that
          event.
        </div>
      ),
    },
    {
      title: 'Principle of Contribution',
      content: (
        <div>
          According to the Principle of Contribution, an insurer who has already paid the amount of claim to the insured
          has a complete right to recover the proportionate contribution from the other insurer. In other words, the
          principle states that an insured can take more than one policy for a subject or property.
        </div>
      ),
    },
    {
      title: 'Principle of Proximate Cause',
      content: (
        <div>
          Any loss can be caused because of two reasons: Insured Perils and Uninsured Perils. The Principle of Proximate
          Cause states that the insurer is only liable for the losses when they are proximately caused by the perils
          stated in the insurance policy.
        </div>
      ),
    },
  ];

  const { IconRenderer, FormRenderer } = useW3PurchaseFlow(props);
  return (
    <>
      <NextSeo
        title="Other Insurances | PrishaPolicy"
        description=" At PrishaPolicy, we strive to make insurance more accessible and ensure that you get insurance for everything you need."
      />
      <ProductMain color="purple">
        <HeroBackground backgroundColor="purple-200" PurchaseFlowFormRenderer={FormRenderer}>
          <div className="grid-cols-2 lg:grid ">
            <div className="flex flex-col justify-between">
              <div>
                <h1 className="heading-1 pb-3">You name any insurable interest and we can get it insured for you.</h1>
                <p className="text-title-6 max-w-[600px]">
                  At PrishaPolicy, we strive to make insurance more accessible and ensure that you get insurance for
                  everything you need.
                </p>
              </div>
              <IconRenderer />
            </div>
            <div className="flex w-full justify-center">
              <div className="hidden w-3/4 justify-center lg:flex">
                <Image src={heroImage} alt="contact us" />
              </div>
            </div>
          </div>
        </HeroBackground>
        <HeroTicker />
        <ProtectToday productCategoryPrefix={productCategorySlug} maxPerRow={4} items={props.productPaths} />
        <div className="container grid-cols-2 gap-x-24 py-24 lg:grid">
          <div className="flex flex-col justify-center">
            <h3 className="lg:heading-3 heading-4">Other Insurances</h3>
            <p className="prose mt-4">
              Insurance is a way to manage your risk. When you buy insurance, you purchase protection against unexpected
              financial losses.
              <br />
              <br />
              There are many unique insurance policies that are available in the Indian Market that the consumers dont
              even know about. We at PrishaPolicy aim to ensure that all types of insurance should be accessible to
              everyone in India.
              <br />
              <br />
              The Insurance listed in this page may not fall into one category alone and so are labelled as others.
            </p>
          </div>
          <div className="grid place-items-center ">
            <Image src={rightIllustration} alt="other insurance" />
          </div>
        </div>
        <ChoosePlan cards={choosePlanCards} perRow={3} heading="What are the principles of Insurance?" />
        <WhyChooseUs />
        <Faq list={otherfaqList} />
      </ProductMain>
    </>
  );
}

export function getStaticProps() {
  // protectCardCheck(productCategorySlug, productsPathAdder(productCategorySlug));
  const productPaths = productsPathAdder(productCategorySlug);
  return {
    props: {
      ...getPurchaseFlowHeroForms(productCategorySlug).props,
      productPaths,
    },
  };
}
export default LiabilityInsurance;
